module.exports = __webpack_public_path__ + "img/image_2022_07_25T09_12_27_897Z.40eee4f2.png";